import React from 'react';
import { CardContent, CardHeader, CardTitle } from "../../components/ui/card"
import { Button } from "../../components/ui/button"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table"
import { Assignment } from '../../types';

interface AssignmentsListProps {
    assignments: Assignment[];
    onDelete: (id: string) => void;
    onModify: (assignment: Assignment) => void;
  }
  
  const AssignmentsList: React.FC<AssignmentsListProps> = ({ assignments, onDelete, onModify }) => {
    return (
      <>
        <CardHeader>
          <CardTitle>Assignment List</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Date</TableHead>
                <TableHead>Barcode</TableHead>
                <TableHead>Recipient Name</TableHead>
                <TableHead>Recipient Phone</TableHead>
                <TableHead>Locker</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {assignments.map((assignment) => (
                <TableRow key={assignment.id}>
                  <TableCell>{assignment.date?.toLocaleDateString('sr-RS')}</TableCell>
                  <TableCell>{assignment.barcode}</TableCell>
                  <TableCell>{assignment.recipientName}</TableCell>
                  <TableCell>{assignment.recipientPhone}</TableCell>
                  <TableCell>{`${assignment.lockerSize} - ${assignment.lockerType}: ${assignment.assignedLocker}`}</TableCell>
                  <TableCell>
                    <Button variant="outline" size="sm" className="mr-2" onClick={() => onModify(assignment)}>
                      Modify
                    </Button>
                    <Button variant="destructive" size="sm" onClick={() => onDelete(assignment.id)}>
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </>
    );
  };
  
  export default AssignmentsList;
 